import { DeleteOutlined, EditOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import { TrainingsQueryProvider } from "__legacy/queries/trainings/TrainingsQueryProvider";
import { Button, Card, Col, Layout, notification, PageHeader, Popconfirm, Row, Tooltip } from "antd";
import { Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";

const deleteTrainingMutation = gql`
  mutation($id: ID!) {
    deleteTraining(id: $id) {
      training {
        id
        name
      }
    }
  }
`;

export const List: React.FC<{ agency?: true }> = (props) => {
  const { agency } = props;
  const { agencyId, stakeholderId } = useParams();
  const navigate = useNavigate();

  const [execDelete] = useMutation(deleteTrainingMutation, {
    errorPolicy: "none",
    onError: (error) => {
      notification.error({
        message: error.message,
      });
    },
    onCompleted: ({ deleteTraining: { training } }) => {
      notification.success({
        message: `Training "${training.name}" deleted`,
      });
    },
    refetchQueries: ["TrainingsQuery"],
  });

  return (
    <TrainingsQueryProvider variables={{ agencyId, stakeholderId }}>
      {({ trainings }) => (
        <Fragment>
          <PageHeader
            ghost={true}
            title="Trainings"
            extra={
              agency && (
                <Button onClick={() => navigate("new")} type="primary">
                  <PlusOutlined />
                  New
                </Button>
              )
            }
          />
          <Layout.Content className="content">
            <Row gutter={[16, 16]}>
              {trainings.map((training) => (
                <Col key={training.id} lg={8}>
                  <Card
                    title={training.name}
                    actions={
                      agency && [
                        <EditOutlined onClick={() => navigate(`${training.id}/edit`)} />,
                        <Popconfirm
                          title="Are you sure?"
                          icon={<QuestionCircleOutlined />}
                          onConfirm={() => execDelete({ variables: { id: training.id } })}
                        >
                          <Tooltip title="Delete" placement="bottom">
                            <DeleteOutlined style={{ color: "#ff4d4f" }} />
                          </Tooltip>
                        </Popconfirm>,
                      ]
                    }
                  >
                    <div style={{ minHeight: "200px" }}>
                      <strong>Institution: </strong>
                      <br />
                      {training.institution}
                      <br />
                      <strong>Start year: </strong>
                      {training.startYear}
                      <br />
                      <strong>End year: </strong>
                      {training.endYear}
                      <br />
                      <strong>Qualification: </strong>
                      {training.qualification}
                      <br />
                      <strong>Details: </strong>
                      {training.details}
                      <br />
                      {training.certificate && (
                        <Fragment>
                          <strong>Certificate: </strong>
                          <a href={training.certificate} download>
                            Download
                          </a>
                        </Fragment>
                      )}
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </Layout.Content>
        </Fragment>
      )}
    </TrainingsQueryProvider>
  );
};
